import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["row"]

  toggleActiveRow(event) {
    this.rowTargets.forEach(row => {
      row.classList.remove("selected-row")
    })

    event.currentTarget.classList.add("selected-row")
  }

}